import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TokenService } from '../token/token.service';


@Injectable({ providedIn: 'root' })
export class RegistroService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient, private tokenService: TokenService) {}

  getRegistros(page: number, size: number): Observable<any> {
    const token = this.tokenService.getToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;

    let params = new HttpParams()
    .set('page', page.toString())
    .set('size', size.toString());


    return this.http.get<any>(`${this.apiUrl}registro`, { headers, params}).pipe(map(
      response => {
        return {
          content: response?.content?.content || [],
          totalElements: response?.content?.totalElements || 0,
          totalPages: response?.content?.totalPages || 0
        }
      }));
  }

  getRegistrosPendentes(dataInicio: string, dataFim: string, pendente:Boolean): Observable<any> {
    const token = this.tokenService.getToken();
    const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;

    let params = new HttpParams()
      .set('inicioCorte', dataInicio)
      .set('fimCorte', dataFim)
      .set('pendente', pendente.toString());

    return this.http.get<any>(`${this.apiUrl}registro/pendentes`, { headers, params }).pipe(
      map(response => ({
          content: response?.content || [],
          totalElements: response?.totalElements || 0,
          totalPages: response?.totalPages || 0
      }))
    );
}

downloadRegistros(dataInicioCorte: string, dataFimCorte: string, atualizarStatusComoEnviado: boolean): Observable<any> {
  const token = this.tokenService.getToken();
  const headers = token ? new HttpHeaders({
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  }) : undefined;

  const url = `${this.apiUrl}registro/download?dataInicioCorte=${encodeURIComponent(dataInicioCorte)}&dataFimCorte=${encodeURIComponent(dataFimCorte)}&atualizarStatusComoEnviado=${encodeURIComponent(atualizarStatusComoEnviado)}`;

return this.http.get(url, { headers, responseType: 'blob' });
}

downloadMatricula(matricula: string): Observable<Blob> {
  const token = this.tokenService.getToken();
  const headers = token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : undefined;

  const url = `${this.apiUrl}registro/proposta/download/${encodeURIComponent(matricula)}`;

  return this.http.get(url, { headers, responseType: 'blob' });
}


}
